module.exports = __webpack_public_path__ + "assets/dnevnik.3a5fef99.svg";